import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  spinner: {
    stroke: theme.palette.primary.light,
  },
}));

export default useStyles;
